<template>
  <div>
    <b-overlay :show="isLoading" rounded="lg">
      <div v-if="!isLoading && !items.length" class="support-empty">
        <feather-icon icon="ClockIcon" size="28" />
        <span>درخواستی در انتظار اتصال نیست.</span>
      </div>

      <div v-for="item in items" :key="item.id" class="support-item">
        <div class="support-item__who">
          <b-avatar variant="light-primary" size="40">
            <feather-icon icon="UserIcon" />
          </b-avatar>
          <div class="support-item__text">
            <div class="support-item__name">{{ item.studentFullName || `زبان‌آموز #${item.studentId}` }}</div>
            <small class="text-muted">درخواست #{{ item.id }}</small>
          </div>
        </div>

        <div class="support-item__meta">
          <div>زمان رزروشده: <strong>{{ formatHours(item.capacityTime) }}</strong></div>
          <div>تاریخ رزرو: <strong>{{ formatDate(item.createDate) }}</strong></div>
        </div>

        <div class="support-item__picker">
          <!-- داخل صفحه است نه دیالوگ؛ isInDialog لیست را به body می‌برد و در صفحه جابه‌جا باز می‌شد -->
          <MasterPicker @getMaster="(master) => setTeacher(item.id, master)" />
        </div>

        <b-button
          variant="primary"
          class="support-item__action"
          :disabled="!selected[item.id] || isSaving"
          @click="confirmAssign(item)"
        >
          اتصال به پشتیبان
        </b-button>
      </div>
    </b-overlay>

    <div v-if="total > count" class="d-flex justify-content-center mt-2">
      <b-pagination v-model="pageNumber" :total-rows="total" :per-page="count" first-number last-number />
    </div>
  </div>
</template>

<script>
import { BOverlay, BAvatar, BButton, BPagination } from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import MasterPicker from "@/views/components/MasterActiveCourse/MasterPicker.vue";
import { GetSupportAdminList, AssignSupportTeacher, SUPPORT_STATUS } from "@/libs/Api/SupportLesson";
import { formatHours, formatDate } from "./supportFormat";

export default {
  name: "SupportWaitingList",
  components: { BOverlay, BAvatar, BButton, BPagination, MasterPicker },
  emits: ["changed"],
  data() {
    return {
      isLoading: false,
      isSaving: false,
      items: [],
      total: 0,
      count: 10,
      pageNumber: 1,
      // supportLessonId → استاد انتخاب‌شده { userId, fullName }
      selected: {},
    };
  },
  watch: {
    pageNumber() {
      this.load();
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    formatHours,
    formatDate,
    async load() {
      this.isLoading = true;
      try {
        const req = new GetSupportAdminList(this);
        req.setRequestParam({ count: this.count, pageNumber: this.pageNumber, status: SUPPORT_STATUS.payed });
        await req.get((res) => {
          const data = (res && res.data) || {};
          this.items = data.data || [];
          this.total = Number(data.total || 0);
        });
      } catch (error) {
        console.error(error);
        this.toast("دریافت درخواست‌ها انجام نشد", "danger");
      } finally {
        this.isLoading = false;
      }
    },
    setTeacher(supportLessonId, master) {
      this.$set(this.selected, supportLessonId, master && master.userId ? master : null);
    },
    async confirmAssign(item) {
      const teacher = this.selected[item.id];
      if (!teacher) return;
      const ok = await this.$bvModal.msgBoxConfirm(
        `${item.studentFullName || "این زبان‌آموز"} (${formatHours(item.capacityTime)}) به ${teacher.fullName} وصل شود؟`,
        { title: "تأیید اتصال", okTitle: "اتصال", cancelTitle: "انصراف", centered: true, okVariant: "primary" }
      );
      if (ok) this.assign(item, teacher);
    },
    async assign(item, teacher) {
      this.isSaving = true;
      try {
        let isOk = false;
        const req = new AssignSupportTeacher(this);
        req.setRequestParamDataObj({ supportLessonId: item.id, teacherId: teacher.userId });
        await req.fetch((res) => {
          isOk = !!(res && res.isSuccess);
        });
        if (!isOk) throw new Error("assign failed");
        this.toast(`به ${teacher.fullName} وصل شد`, "success");
        this.$delete(this.selected, item.id);
        this.$emit("changed");
        this.load();
      } catch (error) {
        console.error(error);
        this.toast("اتصال به پشتیبان انجام نشد", "danger");
      } finally {
        this.isSaving = false;
      }
    },
    toast(title, variant) {
      this.$toast({
        component: ToastificationContent,
        props: { title, icon: variant === "success" ? "CheckIcon" : "AlertTriangleIcon", variant },
      });
    },
  },
};
</script>

<style scoped src="./supportList.css"></style>
